import * as Sentry from '@sentry/vue'

function captureApiError(handler, path, sourceError) {
  const error = new Error()

  // If it's our custom API error
  if (sourceError?.code && sourceError?.message) {
    error.name = `Custom: ${sourceError.code} - ${path} - ${handler}`
    error.code = sourceError.code
    error.message = sourceError.message
  } else {
    // If it's not our custom API error
    error.name = `Not described: ${sourceError}`
  }

  Sentry.captureException(error)
}

function addBreadcrumbsBeforeApiRequest(handler, path, payload) {
  Sentry.addBreadcrumb({
    category: 'Payload for API request',
    message: `${handler} - ${path}`,
    data: payload,
    level: 'info',
  })
}

export { captureApiError, addBreadcrumbsBeforeApiRequest }
